import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueI18n from 'vue-i18n';
import messages from './lang';
import constPlugin from "./config";
Vue.use(constPlugin);
Vue.use(require('vue-moment'));
Vue.use(VueI18n)
Vue.config.productionTip = false
var language = 'fr'
const i18n = new VueI18n({
	locale: language, // set locale
	messages, // set locale messages
})
new Vue({
  i18n,	
  router,
  render: h => h(App)
}).$mount('#app')
